// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"68b1a279","585":"65a4024c"}[chunkId] + ".chunk.js";
};